import { Directive, Input, HostListener, Renderer2, ElementRef, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

export const NUMBER_INPUT_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => NumberInputDirective),  // tslint:disable-line: no-forward-ref
  multi: true
};

@Directive({
  selector: 'input[type=text][appNumberInput][ngModel]',
  providers: [NUMBER_INPUT_VALUE_ACCESSOR]
})
export class NumberInputDirective implements ControlValueAccessor {

  @HostListener('change', ['$event.target.value'])
  @HostListener('input', ['$event.target.value'])
  onChange: (_: any) => void = () => {}

  @HostListener('blur')
  onTouched: () => void = () => {}

  value: number;

  constructor (
    private _renderer: Renderer2,
    private _elementRef: ElementRef
  ) {}

  writeValue(value: number): void {
    let normalizedValue = value == null ? '' : value;
    this._renderer.setProperty(this._elementRef.nativeElement, 'value', normalizedValue);
  }

  registerOnChange(fn: (value: number) => void): void {
    this.onChange = value => {
      this.value = this.parseNumber(value);
      fn(this.value);
    };
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = () => {
      if (this.value === null) {
        this.writeValue(null);
      }
      fn();
    };
  }

  setDisabledState?(isDisabled: boolean): void {
    this._renderer.setProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
  }

  parseNumber(value): number {
    return this.isNumber(value) ? parseFloat(value) : null;
  }

  isNumber(value): boolean {
    return !isNaN(value - parseFloat(value));
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/directives/number-input.directive.ts